import apiClient from "../axiosClient";
import { apiCallWrapper } from "../utils/commonUtils";
import { EmploymentType } from "../interfaces/user";

class UserService {
    public static async getUsers(filterString: string) {
        const response = await apiCallWrapper(() => apiClient(`/api/v1/user?${filterString}`));
        if (response && response.status === 200) {
            return response.data;
        }
    }

    // PATCH only employment_type on the user resource
    public static async updateUserEmploymentType(username: string, employmentType: EmploymentType) {
        const response = await apiCallWrapper(() =>
            apiClient.patch(`/api/v1/user/${username}`, { employment_type: employmentType })
        );
        if (response && response.status === 200) {
            return response.data;
        }
    }

    public static async updateUserStatus(username: string, comment: string, status: string) {
        const response = await apiCallWrapper(() => apiClient.patch(`/api/v1/registration_details/${username}/status`, {
            comment, status
        }));
        if (response && response.status === 200) {
            return response.data;
        }
    }
}

export default UserService;